module.exports = __webpack_public_path__ + "static/media/team-member-05.7c212386.jpg";